var React = require('react');

function IconImg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.333 5.667v18.666H5.667V5.667h18.666m0-2.667H5.667A2.675 2.675 0 0 0 3 5.667v18.666A2.675 2.675 0 0 0 5.667 27h18.666A2.675 2.675 0 0 0 27 24.333V5.667A2.675 2.675 0 0 0 24.333 3zm-6.48 11.813l-4 5.16L11 16.52l-4 5.147h16l-5.147-6.853z","transform":"translate(-3 -3)"}));
}

IconImg.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconImg;

IconImg.default = IconImg;
